// extracted by mini-css-extract-plugin
export default {"container":"czQbw","small":"peBnj","medium":"_0sJfF","big":"dxS7+","extraBig":"_9d8yF","margin":"j+vqb"};